export enum EAttemptPaymentStatus {
    Paid = 0, // payment was neccessary and it was done
    NotRequired = 1, // payment was not neccessary
    Failed = 2 //payment payment was neccessary but failed
}
